import React from 'react';
import { BodyContentRelatedContent } from '../../types';
import styles from './styles.module.scss';
import * as Card from 'components/Card';

type RelatedContentPropType = {
  component: any;
};
export const RelatedContent: React.FunctionComponent<RelatedContentPropType> =
  ({ component }) => {
    // console.log('PTEST', component);
    return (
      <div className={styles['related-content']}>
        <h2>
          <span>{component.title ? component.title : 'Related Content'}</span>
        </h2>
        <p className={styles.description}>{component.description}</p>
        <Card.ThreeColumn
          data={component.multipleObjectParentModels[0]?.socialMediaCardModels}
          displayDate={true}
        />
      </div>
    );
  };
